<template>
  <div slot="body">
    <bita-form ref="form">
      <div slot="body">
        <div class="row">
          <bita-input
            type="text"
            name="title"
            label="عنوان"
            rules=""
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="formData.title"
          >
            <span slot="actionbtn">
              <a class="text-success" @click="() =>formData.title = product.name">
                <i class="fas fa-copy"></i>
              </a>
            </span>
          </bita-input>
          <bita-textarea
            type="text"
            name="title"
            label="توضیحات"
            rules=""
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="formData.description"
          >
            <span slot="actionbtn">
              <a class="text-success" @click="() =>formData.description = product.short_description">
                <i class="fas fa-copy"></i>
              </a>
            </span>
          </bita-textarea>
          <!-- <bita-input
            type="text"
            name="canonical"
            label="کنونیکال"
            rules=""
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="formData.canonical"
          /> -->
          <!-- <template v-if="$acl.can('view', 'standards')">
            <bita-multiselect
              name="standards"
              ref="standards"
              label="استانداردها"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              :data-source="standards"
              data-text-field="name"
              data-value-field="id"
              v-model="formData.standard_id"
            >
              <span slot="actionbtn">
                <a class="text-success" @click="addStrandard"
                  ><i class="fas fa-plus-circle"></i
                ></a>
              </span>
            </bita-multiselect>
          </template> -->
          <bita-typeahead
            type="text"
            name="name"
            label="کلمه های کلیدی"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="matches"
            v-model="tags"
            @on-search="(e) => loadDataSource(e)"
          />
        </div>
      </div>
    </bita-form>
    <standard-form ref="standardForm" @load-data="getStandards" />
  </div>
</template>
<script>
import { productApi, tagApi, standardApi } from "@/api/apiManagement";
import standardForm from "./../../standards/components/StandardForm";
export default {
  components: {
    standardForm,
  },
  props: {
    title: String,
    isLoading: Boolean,
    largeColWidth: {
      default: "col-12",
    },
    smallColWidth: {
      default: "col-lg-2",
    },
  },
  data() {
    return {
      form: {},
      newTag: "",
      tags: [],
      matches: [],
      formData: {},
      standards: [],
      product:{}
    };
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
  },
  mounted() {
    this.getStandards();
  },
  methods: {
    getStandards() {
      if (this.$acl.can("view", "standards"))
        standardApi.get().then((res) => [(this.standards = res.data.entity)]);
    },
    setInitialValue(_product) {
      this.form = _product;
      if (_product) {
        this.$emit("is-loading", true);
        productApi
          .getProductSeo(_product.id)
          .then((res) => {
            let data = res.data.entity;
            this.product = data;
            this.formData = {
              title: data.seo?.title,
              description: data.seo?.description,
              canonical: data.seo?.canonical,
              standard_id: collect(data.standards)
                .pluck("id")
                .toArray(),
            };
            this.tags = collect(data.tags)
              .pluck("name.fa")
              .toArray();
          })
          .finally(() => {
            this.$emit("is-loading", false);
          });
      }
    },

    loadDataSource(tag) {
      tagApi.findTags({ tag: tag }).then((res) => {
        this.matches = collect(res.data.entity)
          .pluck("name.fa")
          .toArray();
      });
    },

    save() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$emit("is-loading", true);
            productApi
              .saveProductSeo(this.form.id, {
                tags: this.tags,
                ...this.formData,
              })
              .then((res) => {
                this.$emit("on-update", this.form);
                resolve(true);
              })
              .finally(() => {
                this.$emit("is-loading", false);
              })
              .catch((err) => {
                this.setErrors(err.response.data.errors);
                reject(err);
              });
          } else reject(false);
        });
      });
    },

    addStrandard() {
      this.$toggleModal("#standard-form");
      this.$refs.standardForm.setInitialData({});
    },

    validate() {
      return this.$refs.form.validate();
    },

    setErrors(err) {
      this.$refs.form.setErrors(err);
    },

    reset() {
      this.form = {};
      this.tags = [];
      this.formData = {};
      this.$refs.standards.emptyKendo();
      this.formRef.reset();
    },
  },
};
</script>
<style scoped>
ul.dropdown-list {
  border: 1px solid #ccc;
  border-radius: 0 0 5px 5px;
  padding: 0;
  position: absolute;
  width: 87%;
  background: #fff;
}
li {
  list-style: none;
  padding: 5px 12px;
}
li a {
  color: #585858;
}
li:hover {
  background: #adadad;
}
</style>
